import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../core';
import ToggleButton from './ToggleButton';

export type ToggleButtonGroupType = {
  label: string;
  value: string;
};

export interface ToggleButtonGroupProps {
  size: 'xsmall' | 'small' | 'medium' | 'large';
  onChange: (value: ToggleButtonGroupType) => void;
  disabled?: boolean;
  buttons: ToggleButtonGroupType[];
  selected: ToggleButtonGroupType;
}

const SwitchContainer = styled.div`
  align-items: center;
  display: flex;
  background-color: ${colors.neutral200};
  padding: 4px;
  width: 100%;
  border-radius: 4px;
`;

const ToggleButtonGroup = ({
  onChange,
  buttons,
  selected,
  disabled,
  size,
}: ToggleButtonGroupProps) => {
  return (
    <SwitchContainer>
      {buttons.length &&
        buttons.map((button) => (
          <ToggleButton
            onClick={() => onChange(button)}
            size={size}
            disabled={disabled}
            selected={button.value === selected.value}
          >
            {button.label}
          </ToggleButton>
        ))}
    </SwitchContainer>
  );
};

export default ToggleButtonGroup;
